import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import { OfflinePaymentRequestedPropTypes } from "./types";
import { useCommonFeatures } from "context/commonFeatures";
import { useCancelOfflineTransaction } from "shared/dataloader";
import { ApiOfflinePurchaseOrderUpdateRequest } from "shared/types/ApiOfflinePurchaseOrderUpdateRequest";
import { PaymentWrapperView } from "shared/components/paymentWrapper/enum";

export function useOfflinePaymentRequestedService({
  errorHandler,
  offlineTransactionCancelSuccessHandler,
  ...props
}: OfflinePaymentRequestedPropTypes) {
  const copies = useCopies();
  const { initConfirmationAlert } = useCommonFeatures();
  const { mutateAsync: cancelOfflineTransaction } = useCancelOfflineTransaction();

  const cancelRequestClickHandler = React.useCallback(() => {
    const reqObj: ApiOfflinePurchaseOrderUpdateRequest = {
      purchaseOrderId: props.purchaseOrderId,
      registrationParticipantId: props.registrationParticipantId as string,
      uiVersion: props.registrationParticipantUiVersion as number
    };
    initConfirmationAlert({
      message: copies.get("offline.payment.cancel.request.confirmation.msg"),
      handleConfirm: async () => {
        try {
          const data = await cancelOfflineTransaction(reqObj);
          offlineTransactionCancelSuccessHandler?.(data);
        } catch (e) {
          errorHandler?.(e);
        }
        return true;
      }
    });
  }, [
    copies,
    errorHandler,
    props.purchaseOrderId,
    initConfirmationAlert,
    cancelOfflineTransaction,
    props.registrationParticipantId,
    props.registrationParticipantUiVersion,
    offlineTransactionCancelSuccessHandler
  ]);

  const updateOfflinePaymentRequestClickHandler = React.useCallback(() => {
    props.dispatch.setPaymentWrapperView(PaymentWrapperView.OFFLINE_PAYMENT);
  }, [props.dispatch]);

  const showPaymentModesClickHandler = React.useCallback(() => {
    initConfirmationAlert({
      message: copies.get("offline.payment.change.payment.mode.confirmation.msg"),
      handleConfirm: () => {
        props.dispatch.setShowPaymentModes(true);
        props.dispatch.setPaymentWrapperView(PaymentWrapperView.PAY_BY_SELF);
      }
    });
  }, [copies, props.dispatch, initConfirmationAlert]);

  return { cancelRequestClickHandler, showPaymentModesClickHandler, updateOfflinePaymentRequestClickHandler };
}
